import { render } from "./DateFields.vue?vue&type=template&id=327b9389"
import script from "./DateFields.vue?vue&type=script&lang=js"
export * from "./DateFields.vue?vue&type=script&lang=js"
script.render = render

export default script